import { useContext } from 'react';
import { MessageBannerContext } from '../contexts/message-banner-context';

const useMessageBanner = () => useContext(MessageBannerContext);

export default useMessageBanner;
